import { motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';

import { ACCENT_BLUE, EASE_EXPO, EVIL_RED, NOPING_GREEN } from '../constants';

export function GlitchTitle() {
  const { t } = useTranslation(['components/trial/lp/v2a']);

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `@keyframes v2a-glitch-1 { 0%, 100% { clip-path: inset(42% 0 58% 0); transform: translate(-3px, 1px); } 20% { clip-path: inset(88% 0 2% 0); transform: translate(2px, -2px); } 40% { clip-path: inset(5% 0 70% 0); transform: translate(-1px, 3px); } 60% { clip-path: inset(30% 0 50% 0); transform: translate(3px, -1px); } 80% { clip-path: inset(65% 0 10% 0); transform: translate(-2px, 2px); } } @keyframes v2a-glitch-2 { 0%, 100% { clip-path: inset(55% 0 30% 0); transform: translate(3px, -1px); } 20% { clip-path: inset(12% 0 82% 0); transform: translate(-2px, 2px); } 40% { clip-path: inset(75% 0 5% 0); transform: translate(1px, -3px); } 60% { clip-path: inset(20% 0 60% 0); transform: translate(-3px, 1px); } 80% { clip-path: inset(82% 0 3% 0); transform: translate(2px, -2px); } } .v2a-glitch { position: relative; } .v2a-glitch::before, .v2a-glitch::after { content: attr(data-text); position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; } .v2a-glitch::before { color: ${EVIL_RED}; animation: v2a-glitch-1 4s infinite linear alternate-reverse; z-index: -1; } .v2a-glitch::after { color: ${ACCENT_BLUE}; animation: v2a-glitch-2 4s infinite linear alternate-reverse; z-index: -1; }`,
        }}
      />

      <div className='flex flex-col items-center'>
        <motion.div initial={{ x: -400, opacity: 0, rotateZ: -5 }} animate={{ x: 0, opacity: 1, rotateZ: 0 }} transition={{ duration: 0.8, ease: EASE_EXPO }}>
          <h1 className='v2a-glitch select-none text-[12vw] font-bold leading-[0.82] tracking-[-0.04em] md:text-[9vw] lg:text-[7vw]' style={{ fontFamily: 'var(--font-bai)', color: EVIL_RED }} data-text={t('hero.glitch_lag')}>
            {t('hero.glitch_lag')}
          </h1>
        </motion.div>

        <motion.div initial={{ scale: 4, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.6, delay: 0.2, ease: EASE_EXPO }}>
          <h1 className='select-none text-[12vw] font-bold leading-[0.82] tracking-[-0.04em] text-white/20 md:text-[9vw] lg:text-[7vw]' style={{ fontFamily: 'var(--font-bai)' }}>
            {t('hero.glitch_is')}
          </h1>
        </motion.div>

        <motion.div className='relative' initial={{ x: 400, opacity: 0, rotateZ: 5 }} animate={{ x: 0, opacity: 1, rotateZ: 0 }} transition={{ duration: 0.8, delay: 0.35, ease: EASE_EXPO }}>
          <h1
            className='select-none text-[12vw] font-bold leading-[0.82] tracking-[-0.04em] md:text-[9vw] lg:text-[7vw]'
            style={{
              fontFamily: 'var(--font-bai)',
              background: `linear-gradient(135deg, ${NOPING_GREEN}, ${ACCENT_BLUE})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {t('hero.glitch_dead')}
          </h1>
          <motion.div className='absolute start-0 top-1/2 h-[3px] -translate-y-1/2 md:h-[4px]' style={{ background: NOPING_GREEN }} initial={{ width: '0%' }} animate={{ width: '100%' }} transition={{ duration: 0.4, delay: 0.9, ease: EASE_EXPO }} />
        </motion.div>
      </div>
    </>
  );
}
